<div class="row patient-three-row">
  @for (catalog of catalogsList; track catalog) {
    <div
      class="col-xs-12 col-sm-12 col-md-4 patient-card checkout-details desktop-view">
      <img
        [src]="getImage(catalog.localizedPicture)"
        alt=""
        class="flu-poster" />
      @if (isVideo(catalog.localizedPicture)) {
        <video
          controls
          class="flu-poster">
          <source [src]="getImage(catalog.localizedPicture)" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      }
      @if (catalog && catalog.localizedPicture) {
        <span
          (click)="openNewModalPopup(catalog.localizedPicture)"
          >
          @if (!isVideo(catalog.localizedPicture)) {
            <img
              src="icons/fullscreen.svg"
              class="fullscreen"
              alt="full" />
          }
        </span>
      }
      <h3 innerHtml="{{ catalog.name }}"></h3>
      <p></p>
      <div class="row numb-img">
        @if (!isVideo(catalog.localizedPicture)) {
          <div
            class="col-xs-6 col-sm-6 col-md-9 p0">
            <p class="poster-numb">
              <span class="bold">{{ catalog.code }}</span>
              |
              {{ catalog?.downloadedMediaType }}
            </p>
          </div>
        }
        @if (!isVideo(catalog.localizedPicture)) {
          <div
            class="col-xs-6 col-sm-6 col-md-3 p0 download-sec">
            <img src="icons/download-icon.svg" alt="download" />
            <a
            (click)="
              downloadFile(catalog.localizedDownloadedMedia, catalog.code)
            ">
              Download
            </a>
          </div>
        }
      </div>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-12 patient-card checkout-details tab-view">
      <img
        [src]="getImage(catalog.localizedPicture)"
        alt=""
        class="flu-poster" />
      @if (isVideo(catalog.localizedPicture)) {
        <video class="flu-poster">
          <source [src]="getImage(catalog.localizedPicture)" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      }
      @if (catalog && catalog.localizedPicture) {
        <span
          (click)="openNewModalPopup(catalog.localizedPicture)"
          >
          @if (!isVideo(catalog.localizedPicture)) {
            <img
              src="icons/fullscreen.svg"
              class="fullscreen"
              alt="full" />
          }
        </span>
      }
      <h3 innerHtml="{{ catalog.name }}"></h3>
      <p></p>
      <div class="row numb-img">
        <div class="col-xs-6 col-sm-6 col-md-9 p0">
          <p class="poster-numb">
            <span class="bold">{{ catalog?.code }}</span>
            |
            {{ catalog?.downloadedMediaType }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 p0 download-sec">
          <img src="icons/download-icon.svg" alt="download" />
          <a
            (click)="
              downloadFile(catalog.localizedDownloadedMedia, catalog.code)
            ">
            Download
          </a>
        </div>
      </div>
    </div>
  }
</div>
